export const worldsSlides = [
    {
        text: 'Collect Dragonstone fragments and summon the Dragon for a shot at massive wins!',
        imageSrc: '/images/sliders/worlds/DS_GameCard.jpg',
        mobileImageSrc: '/images/sliders/worlds/DS_GameCard_Mobile.png',
        logo: '/images/logos/DS.png'
    },
    {
        text: 'Dive into the jungle, uncover ancient riches, and redeem real prizes',
        imageSrc: '/images/sliders/worlds/MA_GameCard.jpg',
        mobileImageSrc: '/images/sliders/worlds/MA_GameCard_Mobile.png',
        logo: '/images/logos/MA.png'
    },
    {
        text: 'Play with up to 50 other players and be the last person to eject to win real prizes!',
        imageSrc: '/images/sliders/worlds/MBC_GameCard.jpg',
        mobileImageSrc: '/images/sliders/worlds/MBC_GameCard_Mobile.png',
        logo: '/images/logos/mbc-worlds-slider-logo.png'
    },
    {
        text: 'Go on an intergalactic adventure. Play against up to 5 players and beat the alien swarm.',
        imageSrc: '/images/sliders/worlds/SX_GameCard.jpg',
        mobileImageSrc: '/images/sliders/worlds/SX_GameCard_Mobile.png',
        logo: '/images/logos/SX.png'
    }
]